var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94642 4.58333V4.58333C8.57643 3.2476 6.73876 2.5 4.82537 2.5H1.6665V15.4167H4.52094C6.60797 15.4167 8.59043 16.3302 9.94642 17.9167V17.9167M9.94642 4.58333V4.58333C11.3164 3.2476 13.1541 2.5 15.0675 2.5H18.3332V15.4167H15.3719C13.2849 15.4167 11.3024 16.3302 9.94642 17.9167V17.9167M9.94642 4.58333V17.9167",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a85c46270c67c465523fd5dc0b95fba9.svg";
export { ForwardRef as ReactComponent };